import { render } from "./ContactInfoModal.vue?vue&type=template&id=afdb19ac&scoped=true"
import script from "./ContactInfoModal.vue?vue&type=script&lang=js"
export * from "./ContactInfoModal.vue?vue&type=script&lang=js"

import "./ContactInfoModal.vue?vue&type=style&index=0&id=afdb19ac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdb19ac"]])

export default __exports__